import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class SpErrorHandler implements ErrorHandler {
    handleError() {
        // TODO: Возможно, тут нужна какая-то логика. Пока что просто подавляем ошибки, чтобы не спамить в консоль.
    }
}
